<template>
	<div id="appBox">
		<div class="ie-warning" id="ieWarning" v-if="detectIE()">
			<p>您正在使用不支持的浏览器版本。请升级到Chrome、Firefox、Edge等现代浏览器以获得最佳体验。</p>
		</div>
		<div id="app">
			<CustomHeader ref="custiomHeader"></CustomHeader>
			<router-view @changeHeaderTab="changeHeaderTab" />
			<CustomFooter @changeHeaderTab="changeHeaderTab"></CustomFooter>
		</div>
		<div id="funcArea" class="funcArea" v-if="showFuncArea">
      <div style="position: absolute; right: 0; top: -20px; opacity: 0.7; cursor: pointer" @click="showFuncArea = false">
        <i class="el-icon-error"></i>
      </div>
			<el-popover placement="left" width="115" trigger="hover">
				<div style="text-align: center;">
					<el-image src="https://test.dzyxedu.com/homeImage/%E9%A2%86%E5%8F%96%E6%96%B0%E4%BA%BA%E7%A4%BC%E5%8C%85.png" fit="fill"></el-image>
					<div>领取新人礼包</div>
				</div>
				<div slot="reference" style="margin-bottom: 11px;text-align: center;">
					<el-image src="https://test.dzyxedu.com/homeImage/%E6%96%B0%E4%BA%BA%E9%A2%86%E8%B1%AA%E7%A4%BC.png" fit="fill"></el-image>
				</div>
			</el-popover>

			<div class="funcCode">
        <div style="text-align: center;" class="guanfanghao">
          <el-image style="width: 30px;" src="https://test.dzyxedu.com/homeImage/icon-%E8%AF%95%E5%90%AC%E8%AF%BE.png" fit="fill"></el-image>
          <div class="funcText">试听课</div>
          <div class="funcMoreCode">
            <div>
              <el-image style="width: 100px; height: 100px;" src="https://test.dzyxedu.com/homeImage/workWxNotice3.png" fit="fill"></el-image>
              <div>主管护师</div>
            </div>
            <div>
              <el-image style="width: 100px; height: 100px;" src="https://test.dzyxedu.com/homeImage/workWxNotice1.png" fit="fill"></el-image>
              <div>初级护师</div>
            </div>
            <div>
              <el-image style="width: 100px; height: 100px;" src="https://test.dzyxedu.com/homeImage/workWxNotice2.png" fit="fill"></el-image>
              <div>护士执业资格</div>
            </div>
          </div>
        </div>
				<div style="text-align: center;" class="guanfanghao">
					<el-image style="width: 30px;" src="https://test.dzyxedu.com/homeImage/barImage2.png" fit="fill"></el-image>
					<div class="funcText">官方号</div>
					<div class="funcMoreCode">
						<div>
							<el-image style="width: 100px; height: 100px;" src="https://test.dzyxedu.com/homeImage/%E5%85%AC%E4%BC%97%E5%8F%B7%E4%BA%8C%E7%BB%B4%E7%A0%81.png" fit="fill"></el-image>
							<div>公众号</div>
						</div>
						<div>
							<el-image style="width: 100px; height: 100px;" src="https://test.dzyxedu.com/homeImage/%E5%B0%8F%E7%BA%A2%E4%B9%A6%E4%BA%8C%E7%BB%B4%E7%A0%81.png" fit="fill"></el-image>
							<div>小红书</div>
						</div>
						<div>
							<el-image style="width: 100px; height: 100px;" src="https://test.dzyxedu.com/homeImage/%E6%8A%96%E9%9F%B3%E5%8F%B7%E4%BA%8C%E7%BB%B4%E7%A0%81.png" fit="fill"></el-image>
							<div>抖音号</div>
						</div>
					</div>
				</div>
				<div style="text-align: center;" class="funcItem">
					<el-popover placement="left" width="115" trigger="hover">
						<div style="text-align: center;">
							<el-image @click="goKefu" src="https://test.dzyxedu.com/homeImage/%E5%BE%AE%E4%BF%A1%E6%89%AB%E7%A0%81%E5%9C%A8%E7%BA%BF%E5%92%A8%E8%AF%A2.png" fit="fill"></el-image>
							<div>微信扫码在线咨询</div>
						</div>
						<div slot="reference">
							<el-image style="width: 30px;" src="https://test.dzyxedu.com/homeImage/barImage3.png" fit="fill"></el-image>
							<div class="funcText">备考咨询</div>
						</div>
					</el-popover>
				</div>
				<!-- <div style="text-align: center;" class="funcItem">
					<el-popover placement="left" width="420" trigger="hover">
						<div style="display: flex; align-items: center; justify-content: space-between;">
							<div style="width: 111px; height: 131px; text-align: center;">
								<el-image src="https://test.dzyxedu.com/homeImage/%E6%8A%A4%E7%90%86%E4%B8%AD%E7%BA%A7%E4%BA%8C%E7%BB%B4%E7%A0%81.png" fit="fill"></el-image>
								<div>护理中级</div>
							</div>
							<div style="width: 111px; height: 131px; text-align: center;">
								<el-image src="https://test.dzyxedu.com/homeImage/%E5%88%9D%E7%BA%A7%E6%8A%A4%E5%B8%88%E4%BA%8C%E7%BB%B4%E7%A0%81.png" fit="fill"></el-image>
								<div>初级护师</div>
							</div>
							<div style="width: 111px; height: 131px; text-align: center;">
								<el-image src="https://test.dzyxedu.com/homeImage/%E6%8A%A4%E5%A3%AB%E8%B5%84%E6%A0%BC%E4%BA%8C%E7%BB%B4%E7%A0%81.png" fit="fill"></el-image>
								<div>护士资格</div>
							</div>
						</div>
						<div slot="reference">
							<el-image style="width: 40px;" src="https://test.dzyxedu.com/homeImage/barImage4.png" fit="fill"></el-image>
							<div class="funcText">备考群</div>
						</div>
					</el-popover>
				</div> -->
				<!-- <div style="text-align: center;" class="funcItem" @click="jumpOpenUrl('https://xcx.dzyxedu.com/validate')">
					<el-image style="width: 30px;" src="https://test.dzyxedu.com/homeImage/barImage1.png" fit="fill"></el-image>
					<div class="funcText">正版验证</div>
				</div> -->
				<div style="text-align: center;" class="funcItem">
					<el-popover placement="left" width="115" trigger="hover">
						<div style="text-align: center;">
							<el-image style="width: 111px; height: 111px; " src="https://test.dzyxedu.com/homeImage/app%E4%B8%8B%E8%BD%BD%E4%BA%8C%E7%BB%B4%E7%A0%81.png" fit="fill"></el-image>
							<div>微信扫码下载APP</div>
						</div>
						<div slot="reference">
							<el-image style="width: 30px;" src="https://test.dzyxedu.com/homeImage/%E6%89%8B%E6%9C%BA.png" fit="fill"></el-image>
							<div class="funcText">APP下载</div>
						</div>
					</el-popover>
				</div>
				<div style="text-align: center;" class="funcItem" @click="backUp">
					<el-image style="width: 20px; height: 20px;" src="https://test.dzyxedu.com/homeImage/%E8%BF%94%E5%9B%9E%E9%A1%B6%E9%83%A8.png" fit="fill"></el-image>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import CustomHeader from './components/CustomHeader.vue';
	import CustomFooter from './components/CustomFooter.vue';
	import DisableDevtool from 'disable-devtool';

	import { apiSetOnline } from './api/api';
	import Cookies from 'js-cookie';
	const TokenKey = 'Admin-Token';
	export default {
		name: 'App',
		components: { CustomHeader, CustomFooter },
    data() {
      return {
        showFuncArea: true
      }
    },
		mounted() {
			DisableDevtool();
			this.getAllZoom();
			if (!!Cookies.get(TokenKey)) {
				const info = JSON.parse(Cookies.get(TokenKey));
				apiSetOnline({ online_key: `50#${info.studentInfo.studentId}` });
				setInterval(() => {
					apiSetOnline({ online_key: `50#${info.studentInfo.studentId}` });
				}, 300 * 1000);
			}
		},
		methods: {
			// 获取缩放倍数（1*系统缩放倍数*浏览器缩放倍数）
			getZoom() {
				let zoom = 1;
				const screen = window.screen,
					ua = navigator.userAgent.toLowerCase();

				if (window.devicePixelRatio !== undefined) {
					zoom = window.devicePixelRatio;
				} else if (~ua.indexOf('msie')) {
					if (screen.deviceXDPI && screen.logicalXDPI) {
						zoom = screen.deviceXDPI / screen.logicalXDPI;
					}
				} else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
					zoom = window.outerWidth / window.innerWidth;
				}
				return this.getDecimal(zoom);
			},

			getDecimal(num) {
				return Math.round(num * 100) / 100;
			},

			getAllZoom() {
				// 总缩放倍数
				const zoom = this.getZoom();
				// 屏幕分辨率
				const screenResolution = window.screen.width;
				// 获取浏览器内部宽
				const browserWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
				// 浏览器缩放倍数
				// 浏览器外部宽度不受浏览器缩放影响，浏览器内部宽度受影响,所以根据这个可以计算出浏览器缩放倍数（F12调试工具的占位会影响该值）
				const browserZoom = this.getDecimal(window.outerWidth / browserWidth);
				// 系统缩放倍数
				const systemZoom = this.getDecimal(zoom / browserZoom);
				// 系统分辨率
				const systemResolution = Math.round(screenResolution * systemZoom);

				console.log(
					'系统分辨率',
					systemResolution,
					'屏幕分辨率',
					screenResolution,
					'浏览器外部宽度',
					window.outerWidth,
					'浏览器内部宽度',
					browserWidth,
					'总缩放倍数',
					zoom,
					'浏览器缩放倍数',
					browserZoom,
					'系统缩放倍数',
					systemZoom
				);
				const app = document.getElementById('app');
				const appBox = document.getElementById('appBox');
				const funcArea = document.getElementById('funcArea');
				const scale = document.body.clientWidth / app.clientWidth;
				app.style.transform = `scale(${scale})`;
				app.style.transformOrigin = 'top left';
				document.body.style.overflowX = 'hidden';
				document.body.style.height = app.clientHeight * scale + 'px';
				appBox.style.height = app.clientHeight * scale + 'px';
				appBox.style.userSelect = 'none';
				funcArea.style.transformOrigin = 'bottom right';
				funcArea.style.bottom = 50 * scale + 'px';
				funcArea.style.transform = `scale(${scale})`;
				// return {
				// 	zoom,
				// 	browserZoom,
				// 	systemZoom,
				// 	systemResolution,
				// };
			},
			backUp() {
				window.scrollTo({
					top: 0, // 滚动到页面顶部
					behavior: 'smooth', // 平滑滚动
				});
			},
			jumpOpenUrl(url) {
				window.open(url);
			},
			changeHeaderTab(path) {
				this.$refs.custiomHeader.handleSelectByPath(path);
			},

			goKefu() {
				window.open('https://im.useasy.cn/?channelId=hK0y4MZk2R6oMgtF&imUrlTitle=官官&imFromUrl=https://xcx.dzyxedu.com/');
			},

			detectIE() {
				const ua = window.navigator.userAgent;
				const msie = ua.indexOf('MSIE ');
				const trident = ua.indexOf('Trident/');

				return msie > 0 || trident > 0;
			},
		},
	};
</script>

<style>
	@keyframes costumPulse {
		0% {
			-webkit-transform: scaleX(1);
			transform: scaleX(1);
		}

		50% {
			-webkit-transform: scale3d(1.1, 1.1, 1.1);
			transform: scale3d(1.1, 1.1, 1.1);
		}

		100% {
			-webkit-transform: scaleX(1);
			transform: scaleX(1);
		}
	}

	body {
		margin: 0;
		padding: 0;
		background-color: rgba(245, 246, 248, 1);
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		overflow-y: hidden;
		min-width: 1903px;
	}

	.funcArea {
		position: fixed;
		right: 20px;
		bottom: 50px;
		width: 80px;
		z-index: 99999;
	}

	.funcCode {
		width: 60px;
		/* height: 410px; */
		opacity: 1;
		border-radius: 86px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
		margin: 0 auto;
		padding: 23px 0;
		box-sizing: border-box;
		cursor: pointer;
	}

	.guanfanghao:hover .funcMoreCode {
		display: flex;
	}

	.funcItem:hover {
		animation-name: costumPulse;
		animation-duration: 2s;
	}

	.funcText {
		font-size: 12px;
		font-weight: 500;
		letter-spacing: 0px;
		line-height: 17.38px;
		color: rgba(140, 140, 140, 1);
		text-align: center;
		vertical-align: top;
		padding-bottom: 6px;
		border-bottom: 1px solid rgb(222, 222, 222);
		margin-bottom: 10px;
	}

	.funcMoreCode {
		width: 469px;
		height: 156px;
		opacity: 1;
		background-image: url('./assets/funcBg.png');
		background-size: 100%;
		position: absolute;
		top: 40px;
		right: 75%;
		padding: 10px 55px 10px 23px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		display: none;
	}

	.ie-warning {
		display: none;
		background: #ff4444;
		color: white;
		padding: 10px;
		text-align: center;
	}

	/deep/ .el-popover {
		min-width: 120px !important;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue